module.exports = __webpack_public_path__ + "img/image 50.6517f105.svg";